'use client'

import { useContext, useEffect } from 'react'
import { ModalContext, ModalContextType } from '../../context/ModalContext'
import { gtmPush } from '../../utils/gtmHelpers'
import ModalContact from '../Modal/ModalContact'

const ProductReassureBlockEvent = () => {
  const { addModal } = useContext(ModalContext) as ModalContextType

  const gtmEvent = () => {
    gtmPush({
      event: 'contact_action',
      contact_action_type: 'contact_telephone',
    })
  }

  useEffect(() => {
    const contactLinkEl =
      typeof document !== 'undefined' &&
      document.querySelector<HTMLElement>('.reassure-contactform')
    const phoneLinkEl =
      typeof document !== 'undefined' && document.querySelector<HTMLElement>('.reassure a.phone')

    if (!contactLinkEl) {
      return () => {}
    }

    const openContactModal = () => {
      const uuid = crypto.randomUUID()
      addModal({
        uuid,
        component: <ModalContact uuid={uuid} />,
      })
    }

    contactLinkEl.addEventListener('click', openContactModal)

    if (phoneLinkEl) {
      phoneLinkEl.addEventListener('click', () => gtmEvent())
    }

    return () => {
      contactLinkEl.removeEventListener('click', openContactModal)
    }
  }, [])

  return null
}

export default ProductReassureBlockEvent
